import React from "react";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import { IconButton } from "@material-ui/core";
import DevicesRoundedIcon from "@material-ui/icons/DevicesRounded";
import DynamicFeedRoundedIcon from "@material-ui/icons/DynamicFeedRounded";
import SearchRoundedIcon from "@material-ui/icons/SearchRounded";
import LockOpenOutlinedIcon from "@material-ui/icons/LockOpenOutlined";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import PersonOutlineRoundedIcon from "@material-ui/icons/PersonOutlineRounded";
import {
  MESSAGE_USER_BLOCK,
  MESSAGE_USER_UNBLOCK,
  ROUTES_DEVICES,
  ROUTES_SESSIONS,
  ROUTES_USERS,
  USER_STATUS_ACTIVE,
  USER_STATUS_BLOCK,
  USER_STATUS_BLOCKED,
  USER_STATUS_UNBLOCK,
} from "../../../../../utils/constants";
import { setIdCrmAction, setIdUserAction, setUserTypeAction } from "../../../../../reducers";
import { useDispatch } from "react-redux";
import { postBlockUser } from "../../../../../api";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

const UserActionsComponent = ({ classes, user, handleResponse, storedIdCrm, handleUpdateLoginModal }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const storageIdCrm = localStorage.getItem("masbranIdCrm");

  const unavailableStatus =
    user?.estadoUsuario?.descripcion !== USER_STATUS_BLOCKED && user?.estadoUsuario?.descripcion !== USER_STATUS_ACTIVE;

  const handleGoToUser = (row) => {
    const userType = { id: row.idUsuario, type: row.tipoUsuario.descripcion };
    dispatch(setUserTypeAction(userType));

    if (!storedIdCrm || storedIdCrm !== user.idCrm) {
      dispatch(setIdCrmAction(user.idCrm));
    }

    if (!storageIdCrm || storageIdCrm !== user.idCrm) {
      localStorage.setItem("masbranIdCrm", user.idCrm);
    }

    navigate(`${ROUTES_USERS}/${row.idUsuario}`);
  };

  const handleRedirectToDevices = (id) => {
    dispatch(setIdCrmAction(user.idCrm.toString()));
    dispatch(setIdUserAction(id.toString()));
    navigate(ROUTES_DEVICES);
  };

  const handleRedirectToSessions = (id) => {
    dispatch(setIdCrmAction(user.idCrm.toString()));
    dispatch(setIdUserAction(id.toString()));
    navigate(ROUTES_SESSIONS);
  };

  const handleBlockUser = (blockUser, idUser) => {
    const body = { operacion: blockUser, idUsuario: idUser };
    const message = { id: blockUser === USER_STATUS_BLOCK ? MESSAGE_USER_BLOCK : MESSAGE_USER_UNBLOCK, options: {} };
    postBlockUser(storedIdCrm || user.idCrm, body, handleResponse, message);
  };

  return (
    <Grid item spacing={2} container justifyContent={"flex-end"} alignItems={"center"}>
      <Grid item xs={2}>
        <Tooltip title={intl.formatMessage({ id: "menu.device_list" })}>
          <IconButton className={classes.button} onClick={() => handleRedirectToDevices(user.idUsuario)}>
            <DevicesRoundedIcon />
          </IconButton>
        </Tooltip>
      </Grid>
      <Grid item xs={2}>
        <Tooltip title={intl.formatMessage({ id: "menu.session_list" })}>
          <IconButton className={classes.button} onClick={() => handleRedirectToSessions(user.idUsuario)}>
            <DynamicFeedRoundedIcon />
          </IconButton>
        </Tooltip>
      </Grid>
      <Grid item xs={2}>
        {user.estadoUsuario?.descripcion === USER_STATUS_BLOCKED ? (
          <Tooltip title={intl.formatMessage({ id: "custom.user.unblock" })}>
            <span>
              <IconButton
                className={classes.button}
                disabled={unavailableStatus}
                onClick={() => handleBlockUser(USER_STATUS_UNBLOCK, user.idUsuario)}
              >
                <LockOpenOutlinedIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : (
          <Tooltip title={intl.formatMessage({ id: "custom.user.block" })}>
            <span>
              <IconButton
                className={classes.button}
                disabled={unavailableStatus}
                onClick={() => handleBlockUser(USER_STATUS_BLOCK, user.idUsuario)}
              >
                <LockOutlinedIcon />
              </IconButton>
            </span>
          </Tooltip>
        )}
      </Grid>
      <Grid item xs={2}>
        <Tooltip title={intl.formatMessage({ id: "custom.user.update_login" })}>
          <span>
            <IconButton
              className={classes.button}
              disabled
              onClick={() => handleUpdateLoginModal(user.idUsuario, user.idLogin)}
            >
              <PersonOutlineRoundedIcon />
            </IconButton>
          </span>
        </Tooltip>
      </Grid>
      <Grid item xs={2}>
        <Tooltip title={intl.formatMessage({ id: "custom.user.view_user_detail" })}>
          <IconButton className={classes.button} onClick={() => handleGoToUser(user)}>
            <SearchRoundedIcon />
          </IconButton>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default UserActionsComponent;
